import React, { Component } from 'react';
import StarRadioButton from 'components/StarRadioButton/StarRadioButton';
import './StarRadioButtonList.scss';

const StarRadioButtonList = (props) => {
    /**
     * Constructs the list of star radio buttons used for customer feedback.
     * One button for each possible star value.
     */
    const buildRadioButtons = () => {
        const starAnswerTypes = [1, 2, 3, 4, 5];
        const starRatings = starAnswerTypes.map((answer) => {
            const starRatingId = 'star' + answer;
            const starRatingLabel = answer + ' stars';

            return (
                <StarRadioButton
                    htmlFor={starRatingId}
                    isChecked={props.answerValue === answer}
                    key={starRatingId}
                    onChange={handleChange}
                    radioButtonId={starRatingId}
                    starRatingLabel={starRatingLabel}
                    title={starRatingLabel}
                    starValue={answer}
                />
            );
        });

        return (
            <div className='stars'>
                {starRatings.reverse()}
            </div>
        );
    };

    /**
     * Called when a star input value is clicked. This function gets the
     * value attribute of the star/input and sets the state with it.
     *
     * @param     event : {Native Event Object}
     */
    const handleChange = (event) => {
        const value = parseInt(event.target.value);

        if (props.questionType) {
            props.handleClick({
                type: props.questionType,
                rating: value,
                tdIndex: props.tdIndex
            });
        } else {
            props.handleClick(value);
        }
    };

    return (
        <div className='star-rating-wrapper'>
            {buildRadioButtons()}
        </div>
    );
};

export default StarRadioButtonList;



// WEBPACK FOOTER //
// ./application/components/StarRadioButtonList/StarRadioButtonList.jsx